import { jsxs as W, jsx as o } from "react/jsx-runtime";
import { useState as c, useRef as C, useEffect as x } from "react";
import e from "./style.module.less.js";
const V = (f) => {
  const [h, w] = c(""), [y, l] = c(!1), {
    isSelectorEnabled: d,
    selectedAiLawyer: a,
    aiLawyers: L,
    onAiLawyerChange: P,
    headerContainerRef: $,
    chatContainerRef: g
  } = f, [v, u] = c(!1), S = C(null), [M, m] = c("topMiddle"), N = 76, I = 312, n = C(null), E = (t) => {
    P && P(t), u(!1);
  };
  x(() => {
    a && ((p) => {
      const r = L.find(
        (s) => s.aiLawyer === p
      );
      r && (w(r.image), l(!0));
    })(a);
  }, [a, L]);
  const b = () => {
    var t, p;
    if (n.current && clearTimeout(n.current), $ && g && g.current) {
      const r = ((t = $.current) == null ? void 0 : t.getBoundingClientRect()) || { bottom: 0 }, s = g.current.getBoundingClientRect(), i = (p = S.current) == null ? void 0 : p.getBoundingClientRect();
      r && i && s && (r.bottom < i.top - N && s.left < i.left - I / 2 ? m("topMiddle") : r.bottom < i.top - N && s.left >= i.left - I / 2 ? m("topStart") : s.left < i.left - I / 2 ? m("bottomMiddle") : m("bottomStart"));
    }
    u(!0);
  }, R = () => {
    n.current = setTimeout(() => {
      u(!1);
    }, 300);
  }, A = () => {
    n.current && clearTimeout(n.current);
  }, k = () => {
    n.current = setTimeout(() => {
      u(!1);
    }, 300);
  }, T = () => {
    l(!1);
  };
  return /* @__PURE__ */ W("div", { className: e.aiLawyerSelectorWrapper, children: [
    /* @__PURE__ */ o(
      "div",
      {
        className: `${e.aiLawyerIconContainer} ${e.noSelect} ${v && d ? e.hoverEnabled : ""} `,
        onMouseEnter: () => b(),
        onMouseLeave: () => R(),
        ref: S,
        children: y ? /* @__PURE__ */ o(
          "img",
          {
            className: `${e.aiLawyerIcon} ${e.noSelect}`,
            src: h,
            onError: T
          }
        ) : null
      }
    ),
    v && d && /* @__PURE__ */ o(
      "div",
      {
        className: `${e.popupOverlay} ${e.noSelect} ${e[M]}`,
        onMouseEnter: () => A(),
        onMouseLeave: () => k(),
        children: /* @__PURE__ */ o("div", { className: e.aiLawyerPickerWrapper, children: L.map((t) => /* @__PURE__ */ o(
          "div",
          {
            className: `${e.aiLawyerPickerItem} ${a === t.aiLawyer ? e.selectedLawyer : ""}`,
            onClick: () => E(t.aiLawyer),
            children: /* @__PURE__ */ o(
              "img",
              {
                className: `${e.aiLawyerPickerImage} ${e.noSelect}`,
                src: t.image
              }
            )
          },
          t.aiLawyer
        )) })
      }
    )
  ] });
}, O = (f) => {
  const { iconImage: h, className: w, iconClassName: y } = f, [l, d] = c(!1), a = () => {
    d(!0);
  };
  return /* @__PURE__ */ o("div", { className: e.aiLawyerSelectorWrapper, children: /* @__PURE__ */ o("div", { className: `${e.aiLawyerIconContainer} ${e.noSelect} ${w}`, children: l ? null : /* @__PURE__ */ o(
    "img",
    {
      className: `${e.aiLawyerIcon} ${e.noSelect} ${y}`,
      src: h,
      onError: a
    }
  ) }) });
};
export {
  O as AiLawyerPlaceholder,
  V as AiLawyerSelector
};
